import { create, type StateCreator } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type Initializer<T> = StateCreator<
  T,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  T
>;

export const createStore = <T>(initializer: Initializer<T>) =>
  create(immer(devtools(initializer, { enabled: typeof window !== 'undefined' })));
